import { useCallback, useEffect, useState } from 'react';
import { AppState } from 'react-native';

import BetrAnalytics from '@/feature/analytics/analytics';
import { fetchAndCacheAppInstanceId } from '@/feature/analytics/appInstanceId';
import { isAdTrackingPermitted } from '@/utils/advertising';

/**
 * Hook that checks if the app has tracking enabled for App Tracking Transparency (ATT).
 */
export const useTrackingEnabled = () => {
    const [isTargetedAdvertisingEnabled, setIsTargetedAdvertisingEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const checkPermissions = useCallback(async () => {
        // TODO: Add account level check from the API as well here in || (OR) condition to both iOS and Android
        // Account level check will be handling multiple devices with multiple consent
        const isPermissionGranted = await isAdTrackingPermitted();

        setIsTargetedAdvertisingEnabled(isPermissionGranted);
        BetrAnalytics.setConsent(isPermissionGranted);
        fetchAndCacheAppInstanceId();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const subscription = AppState.addEventListener('change', nextAppState => {
            if (nextAppState === 'active') {
                checkPermissions();
            }
        });

        checkPermissions();

        return () => {
            subscription.remove();
        };
    }, [checkPermissions]);

    return { isEnabled: isTargetedAdvertisingEnabled, isLoading };
};
